var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      class: _vm.linkClass,
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [_vm._v(_vm._s(_vm.linkText))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }